module.exports = "<div class=\"msg-row\" *ngIf=\"question.content\">\n    <div class=\"question\">\n        <div class=\"text\">\n            {{ question.content | translate}}\n        </div>\n        <div class=\"footer-question\" *ngIf=\"question.direction === 'to'\">\n            <button *ngFor=\"let response of responses\" (click)=\"callback(response.id)\">{{'common.'+response.value | translate}}</button>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chat/childs/question/question.component.html
// module id = 584
// module chunks = 0